import menu from '@/content/menu.json';
import Menu from './Menu';

export default function FooterMenuTrainings() {
  return <Menu title={menu.trainings.title} items={menu.trainings.items} />;
}
